<script setup lang="ts">
import type { ButtonProps } from '#ui/types';

// COMPOSABLES
const { isMobile } = useResponsive();

// PROPS
defineProps({
    indexI18nKey: { type: String as PropType<TranslationKey>, required: true },
    index: { type: Number, required: true },
    totalItems: { type: Number, required: true },
    title: { type: String, default: undefined },
});

// DATA
const model = defineModel<boolean>({ default: false });
const buttonSize = computed<ButtonProps['size']>(() => (isMobile.value ? 'lg' : 'xl'));
</script>

<template>
    <UModal v-model:open="model" :ui="{ content: 'bg-white/50 backdrop-blur' }" v-bind="modalNoDescAriaFixupProps" fullscreen>
        <template #title>
            <BaseI18nT tag="span" :keypath="indexI18nKey">
                <span>{{ index + 1 }}</span>
                <span>{{ totalItems }}</span>
            </BaseI18nT>
            <span v-if="title">{{ title }}</span>
        </template>
        <template #content>
            <div class="mx-auto flex h-screen max-h-svh w-dvw max-w-332 flex-col items-center justify-center gap-4 p-4 lg:max-h-dvh lg:gap-6 lg:p-6">
                <div class="absolute top-4 z-10 flex w-[calc(100%-2.25rem)] lg:static lg:w-full portrait:static portrait:w-full">
                    <div class="flex flex-1">
                        <UBadge color="primary-dark" variant="solid" size="lg">
                            <BaseI18nT tag="span" :keypath="indexI18nKey">
                                <span>{{ index + 1 }}</span>
                                <span>{{ totalItems }}</span>
                            </BaseI18nT>
                        </UBadge>
                    </div>
                    <div class="flex flex-1 justify-center">
                        <UBadge v-if="title" color="neutral" variant="outline" size="lg"> {{ title }}</UBadge>
                    </div>
                    <div class="flex flex-1 justify-end">
                        <UButton color="primary-dark" icon="lucide:x" :size="buttonSize" @click="model = false" />
                    </div>
                </div>

                <slot />
            </div>
        </template>
    </UModal>
</template>
